module.exports = __webpack_public_path__ + "static/img/yy22.2a581d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy22.jpg
// module id = lI+c
// module chunks = 1